import React, { useMemo } from "react";
import { useTable, useGlobalFilter, useSortBy, usePagination } from "react-table";
import TableComponent from "./TableComponent";
import GlobalSearchFilter from "./GlobalSearchFilter";
import SelectMenu from "./SelectMenu";
import PaginationNav from "./PaginationNav";


// Componente Table para usar en listas de usuarios, licencias, inventario, etc.
const Table = ({ columns, data, showGlobalFilter = true, pagination = true, getRowClassName, getRowStyle }) => {
    const initialState = useMemo(() => ({ pageSize: 5 }), []);
    const pageSizeOptions = useMemo(
        () => [
            { id: 5, caption: "5 items" },
            { id: 10, caption: "10 items" },
            { id: 20, caption: "20 items" },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows: tableRows,
        state,
        setGlobalFilter,
        page: rows,
        canPreviousPage,
        canNextPage,
        pageCount,
        gotoPage,
        setPageSize,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            initialState,
            autoResetPage: false,
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    return (
        <div className="flex flex-col gap-4 bg-slate-100">
            <div className="flex flex-col sm:flex-row justify-between gap-2 mt-1">
                {
                    showGlobalFilter && (
                        <div className="flex flex-col sm:flex-row justify-between gap-2 mt-1">
                            <GlobalSearchFilter
                                className="sm:w-64"
                                globalFilter={state.globalFilter}
                                setGlobalFilter={setGlobalFilter}
                            />
                        </div>
                    )
                }
            </div>
            <TableComponent
                getTableProps={getTableProps}
                headerGroups={headerGroups}
                getTableBodyProps={getTableBodyProps}
                rows={pagination ? rows : tableRows}
                prepareRow={prepareRow}
                getRowClassName={getRowClassName}
                getRowStyle={getRowStyle}
            />
            {
                pagination && (
                    <div className="flex flex-col sm:flex-row justify-between items-center">
                        <PaginationNav
                            gotoPage={gotoPage}
                            canPreviousPage={canPreviousPage}
                            canNextPage={canNextPage}
                            pageCount={pageCount}
                            pageIndex={pageIndex}
                        />

                        <SelectMenu
                            className="sm:w-40"
                            value={pageSize}
                            setValue={setPageSize}
                            options={pageSizeOptions}
                        />
                    </div>
                )
            }
        </div>
    );
};

export default Table;
